import type { InventoryView } from "../types";
import { InfoIcon } from "../../../components/Icons";
import { Overlay } from "../../../components/overlays/Overlay";

export function InventoryHistoryDrawer({ open, inventory, onClose }: {
  open: boolean;
  inventory: InventoryView;
  onClose(): void;
}) {
  return (
    <Overlay open={open} onClose={onClose} title="Inventory information" eyebrow="LOADED NFT RECORDS" variant="sheet">
      <p className="drawer-lead">This panel shows the NFTs loaded in this session. The first page updates periodically; NFTs loaded with Load more retain their original read snapshots.</p>
      <dl className="detail-list">
        <div><dt>Current inventory</dt><dd>{inventory.loading ? "LOADING" : inventory.items === null ? "UNAVAILABLE" : `${inventory.items.length} loaded`}</dd></div>
        <div><dt>Freshness</dt><dd>{inventory.freshnessLabel}</dd></div>
        <div><dt>More active items</dt><dd>{!inventory.available || inventory.items === null ? "Unavailable" : inventory.hasMore ? "Available to load" : "No more pages in the current page sequence"}</dd></div>
      </dl>
      <div className="activity-empty"><InfoIcon /><p>Transfer and redemption history are not available here. A missing NFT in the loaded records does not establish that it was transferred or redeemed.</p></div>
    </Overlay>
  );
}
